import React, { Component } from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { recarregaUsuario } from '../actions/AutenticacaoActions';
import { connection } from '../actions/AplicationActions';

import Atendimento from '../pages/Atendimento';
import Login from '../pages/login';
import Profile from '../pages/profile';
import NotFound from '../pages/notfound';
import Agents from '../pages/supervision/Agents';
import Queues from '../pages/supervision/Queues';
import Dashboard from '../pages/supervision/Dashboard';

import history from './history';

function CustomRoute({ isPrivate, authenticated, employee, isSupervision, ...rest}) {

    if (isPrivate && !authenticated) {   
        return <Redirect to="/login" />
    }
    if (isPrivate && isSupervision && employee !== "supervisor") {   
        return <Redirect to="/notfound" />
    }
    return <Route {...rest} />
}

class Routes extends Component {
// const Routes = props => {

    constructor(props) {
        super(props);

        this.state = { conta: 0, agents: [], intevalID: 0 };
    }

    componentWillMount = async () => {

        let path = history.location;
        const token =  await localStorage.getItem('token');

        if(token) {
            await this.props.recarregaUsuario(token, path);
        }

        window.addEventListener('offline', this.handleNetworkChange);
        // window.addEventListener('online', this.handleNetworkChange)
    }

    // componentWillUnmount() {
    //     window.removeEventListener('offline', this.handleNetworkChange);
    //     window.removeEventListener('online', this.handleNetworkChange);
    // }

    handleNetworkChange = () => {
        this.props.connection(window.navigator.onLine)
    }

    render() {
        return (
            <ConnectedRouter history={history}>
                <Switch>
                    <CustomRoute isPrivate { ...this.props } exact path="/" component={Atendimento} />
                    <CustomRoute isPrivate { ...this.props } exact path="/profile" component={Profile} />

                    <CustomRoute isPrivate isSupervision { ...this.props } exact path="/supervision/agents" component={Agents} />
                    <CustomRoute isPrivate isSupervision { ...this.props } exact path="/supervision/queues" component={Queues} />
                    <CustomRoute isPrivate isSupervision { ...this.props } exact path="/supervision/dashboard" component={Dashboard} />
                    <CustomRoute exact path="/login"  component={Login} />
                    <CustomRoute component={NotFound} />
                </Switch>
            </ConnectedRouter>
        )
    }
}

const mapStateToProps = state => {
    return ({
        authenticated: state.AutenticacaoReducer.authenticated,
        employee: state.AutenticacaoReducer.employee,
    })
}
  
export default connect(mapStateToProps, { recarregaUsuario, connection })(Routes);